export const customModal_Container = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '340px',
  transform: 'translate(-50%, -50%)',
  background: '#F5F5F5',
  boxShadow: ' 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #FFFFFF',
  borderRadius: '16px',
  transition: 'ease-in-out 0.8s !important'
};
